import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import app from './app';
import debug from './debug';
import moveInFeedback from './moveInFeedback';
import autocompleteAddress from './autocompleteAddress';

const rootReducer = (history) => {
  return combineReducers({
    router: connectRouter(history),
    app,
    debug,
    moveInFeedback,
    autocompleteAddress,
  });
};

export default rootReducer;
